(function () {
  var STORAGE_KEY = 'everquilts:wishlist';

  function getItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: items } }));
  }

  function toggleItem(product) {
    var items = getItems();
    var index = items.findIndex(function (item) {
      return item.handle === product.handle;
    });
    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.unshift(product);
    }
    setItems(items);
  }

  function removeItem(handle) {
    setItems(
      getItems().filter(function (item) {
        return item.handle !== handle;
      })
    );
  }

  /*
   * On a product page the shopper has already picked a style and a colour, so
   * save what they are actually looking at rather than the product's default
   * image and price. Scoped to <product-info> on purpose: product cards in a
   * grid have no variant picker, and without the scope a card sitting on a
   * product page would pick up that page's variant.
   */
  function selectedVariant(el) {
    var scope = el.closest('product-info');
    if (!scope) return null;

    var idInput = scope.querySelector('.product-variant-id');
    var json = scope.querySelector('[data-all-variants]');
    if (!idInput || !json) return null;

    var id = Number(idInput.value);
    if (!id) return null;

    var variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (e) {
      return null;
    }
    if (!Array.isArray(variants)) return null;

    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].id === id) return variants[i];
    }
    return null;
  }

  function variantImage(variant) {
    var image = variant && variant.featured_image;
    var src = image && (typeof image === 'string' ? image : image.src);
    if (typeof src !== 'string' || !src) return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }

  function readProductFromButton(button) {
    var el = button.closest('[data-wishlist-product]');
    if (!el) return null;

    var variant = selectedVariant(el);
    var image = variantImage(variant);
    var price = variant && typeof variant.price === 'number' ? variant.price : el.dataset.price;

    return {
      handle: el.dataset.handle,
      id: el.dataset.id,
      title: el.dataset.title,
      url: el.dataset.url,
      image: image || el.dataset.image,
      price: price
    };
  }

  function syncButtons() {
    var handles = getItems().map(function (i) {
      return i.handle;
    });
    document.querySelectorAll('[data-wishlist-product]').forEach(function (el) {
      var active = handles.indexOf(el.dataset.handle) > -1;
      el.classList.toggle('is-active', active);
      var btn = el.querySelector('[data-wishlist-toggle]');
      if (btn) {
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        var label = active ? btn.dataset.labelRemove : btn.dataset.labelAdd;
        if (label) btn.setAttribute('aria-label', label);
      }
    });
  }

  function updateBadge() {
    var count = getItems().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function formatMoney(cents) {
    var value = Number(cents || 0) / 100;
    if (isNaN(value)) value = 0;
    return '$' + value.toFixed(2);
  }

  function renderDrawer() {
    var body = document.querySelector('[data-wishlist-body]');
    if (!body) return;
    var items = getItems();
    var emptyTpl = document.getElementById('WishlistEmptyTemplate');
    var itemTpl = document.getElementById('WishlistItemTemplate');
    body.innerHTML = '';

    if (!items.length) {
      if (emptyTpl) body.appendChild(emptyTpl.content.cloneNode(true));
      return;
    }

    var list = document.createElement('ul');
    list.className = 'wishlist-drawer__list';

    items.forEach(function (item) {
      if (!itemTpl) return;
      var node = itemTpl.content.cloneNode(true);
      var img = node.querySelector('[data-field="image"]');
      if (img) {
        img.src = item.image || '';
        img.alt = item.title || '';
      }
      var link = node.querySelector('[data-field="title"]');
      if (link) {
        link.href = item.url || '#';
        link.textContent = item.title || '';
      }
      var price = node.querySelector('[data-field="price"]');
      if (price) price.textContent = formatMoney(item.price);
      var removeBtn = node.querySelector('[data-wishlist-remove]');
      if (removeBtn) removeBtn.dataset.wishlistRemove = item.handle;
      list.appendChild(node);
    });

    body.appendChild(list);
  }

  function openDrawer() {
    var drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;
    renderDrawer();
    drawer.removeAttribute('hidden');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    document.documentElement.classList.add('wishlist-drawer-open');
    var closeBtn = drawer.querySelector('.wishlist-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    var drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('wishlist-drawer-open');
    setTimeout(function () {
      drawer.setAttribute('hidden', '');
    }, 300);
  }

  document.addEventListener('click', function (event) {
    var toggleBtn = event.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      event.preventDefault();
      var product = readProductFromButton(toggleBtn);
      if (product && product.handle) toggleItem(product);
      return;
    }

    var removeBtn = event.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      event.preventDefault();
      removeItem(removeBtn.dataset.wishlistRemove);
      return;
    }

    if (event.target.closest('[data-wishlist-open]')) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-wishlist-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('wishlist:change', function () {
    syncButtons();
    updateBadge();
    var drawer = document.getElementById('wishlist-drawer');
    if (drawer && !drawer.hasAttribute('hidden')) {
      renderDrawer();
    }
  });

  function init() {
    syncButtons();
    updateBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
